import {
  setLocale,
  addMethod,
  string as yupString,
  mixed as yupMixed,
} from "yup";
import i18n from "~/lib/i18n";

const { t } = i18n.global;

export default function () {
  addMethod(yupString, "charRange", function (type, min, max, message) {
    const labelsPrefix = "labels.";
    const charTypeDetails = {
      digit: {
        charRegExp: "\\d",
        labels: {
          exact: "exactDigitValidationMsg",
          range: "digitRangeLimitValidationMsg",
          min: "minDigitValidationMsg",
          max: "maxDigitValidationMsg",
        },
      },
      any: {
        charRegExp: ".",
        labels: {
          exact: "exactCharValidationMsg",
          range: "charRangeLimitValidationMsg",
          min: "minCharValidationMsg",
          max: "maxCharValidationMsg",
        },
      },
    };
    let regex = new RegExp(
      `^${charTypeDetails[type].charRegExp}{${min || 0},${max || ""}}$`
    );
    let defaultComputedMessage;
    let charLabels = charTypeDetails[type].labels;

    if (min && max && min == max)
      defaultComputedMessage = t(labelsPrefix.concat(charLabels.exact), {
        num: min,
      });
    else if (min && max)
      defaultComputedMessage = t(labelsPrefix.concat(charLabels.range), {
        min,
        max,
      });
    else if (min)
      defaultComputedMessage = t(labelsPrefix.concat(charLabels.min), {
        num: min,
      });
    else if (max)
      defaultComputedMessage = t(labelsPrefix.concat(charLabels.max), {
        num: max,
      });

    return this.matches(regex, message || defaultComputedMessage);
  });

  addMethod(yupMixed, "tLabel", function (labelKey) {
    return this.label(t(labelKey));
  });

  addMethod(yupString, "notConsecutivePhoneNumber", function () {
    return this.notOneOf(
      ["1234567890", "0123456789"],
      t("labels.validPhoneNumber")
    );
  });

  addMethod(yupString, "notRepetitiveNumber", function () {
    return this.test(
      "notRepetitiveNumber",
      t("labels.validPhoneNumber"),
      (value) => !value || value !== value[0].repeat(value.length)
    );
  });

  setLocale({
    mixed: {
      default: t("labels.defaultValidationMsg"),
      required: t("labels.requiredFieldMsg"),
    },
    string: {
      email: t("labels.invalidEmailMsg"),
    },
  });
}
